export default {
    data() {
      return {
        monthStr: [
          "January",
          "February",
          "March",
          "April",
          "May",
          "June",
          "July",
          "August",
          "September",
          "October",
          "November",
          "December"
        ]
      };
    },
    methods: {
    },
    computed: {
      date() {
        return sermon =>
          `${this.monthStr[sermon.month]} ${sermon.day}, ${sermon.year}`;
      },
      eventDay() {
        return date => new Date(date).getDate();
      },
      eventMonth() {
        return date => this.monthStr[new Date(date).getMonth()].substring(0, 3);
      },
      eventDate() {
        return (start, end) => {
          let startDate = new Date(start);
          let endDate = new Date(end);
          var options = {
            weekday: "long",
            year: "numeric",
            month: "long",
            day: "numeric",
            timeZone: "UTC"
          };
          if (startDate.getUTCDate() == endDate.getUTCDate()) {
            // return `${this.monthStr[startDate.getUTCMonth()]} ${startDate.getUTCDate()}, ${startDate.getUTCFullYear()}`
            return startDate.toLocaleString("en", options);
          } else {
            // return `${this.monthStr[startDate.getUTCMonth()]} ${startDate.getUTCDate()}, ${startDate.getUTCFullYear()} -
            //${this.monthStr[endDate.getUTCMonth()]} ${endDate.getUTCDate()}, ${endDate.getUTCFullYear()}`
            options.hour = "numeric";
            options.minute = "numeric";
            return startDate.toLocaleString("en", options);
          }
        };
      },
      eventTime() {
        return (start, end) => {
          let startDate = new Date(start);
          let endDate = new Date(end);
          if (startDate.getUTCDate() == endDate.getUTCDate()) {
            var options = { hour: "numeric", minute: "numeric" };
            return (
              startDate.toLocaleString("en", options) +
              " - " +
              endDate.toLocaleString("en", options)
            );
          } else {
            var options = {
              weekday: "long",
              year: "numeric",
              month: "long",
              day: "numeric",
              hour: "numeric",
              minute: "numeric",
              timeZone: "UTC"
            };
            return endDate.toLocaleString("en", options);
          }
        };
        // return date => {
        //   let d = new Date(date);
        //   let ampm = d.getUTCHours() < 12 ? "am" : "pm";
        //   let hh = d.getUTCHours() % 12;
        //   hh = hh ? hh : 12;
        //   let mn = ("0" + d.getUTCMinutes()).slice(-2);
        //   console.log(d.getUTCHours() + ":" + d.getUTCMinutes());
        //   return `${hh}:${mn}${ampm}`
        // }
      }
    }
  };
  


// WEBPACK FOOTER //
// ./src/mixins/dateMixin.js